const NAMED_DEVICE_STATUS: Record<string, number> = {
  inactive: 0,
  active: 1,
  'new implant': 2,
  pending: 3,
  'entered in error': 4,
};

/** Reads a device status whether the API sent a number or a name such as "Active". */
export function deviceStatusCode(status: unknown): number | null {
  if (status === undefined || status === null || status === '') return null;
  const text = String(status).trim().toLowerCase().replace(/[_-]+/g, ' ');
  if (text in NAMED_DEVICE_STATUS) return NAMED_DEVICE_STATUS[text];
  const numeric = Number(text);
  return Number.isFinite(numeric) ? numeric : null;
}

/** Active, new implant, and pending. Inactive and entered-in-error are left out. */
export function isSchedulableDeviceStatus(status: unknown): boolean {
  const code = deviceStatusCode(status);
  return code === 1 || code === 2 || code === 3;
}

/** Inactive (0) or entered in error (4), whether the API sent a number or a name. */
export function isInactiveDeviceStatus(status: unknown): boolean {
  const code = deviceStatusCode(status);
  return code === 0 || code === 4;
}
